import { useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useCurrentDose } from '~/hooks/dose/useCurrentDose';
import { doseVisibilityState } from '~/state/atoms/dose/doseAtoms';

type UseDoseVisibilityResult = {
    isDoseVisible: boolean;
    toggleDoseVisibility: () => void;
};

/**
 * The dose visibility on/off toggle. The visibility lives in one atom and
 * the display bridge carries it to every drawn dose, so no toggle reaches an
 * Environment of its own.
 */
export default function useDoseVisibility(): UseDoseVisibilityResult {
    const [isDoseVisible, setIsDoseVisible] =
        useRecoilState(doseVisibilityState);

    const toggleDoseVisibility = useCallback(() => {
        setIsDoseVisible((visible) => !visible);
    }, [setIsDoseVisible]);

    return { isDoseVisible, toggleDoseVisibility };
}

/** Whether a dose is shown: one is selected and its visibility is on. */
export function useIsDoseShown(): boolean {
    const currentDose = useCurrentDose();
    const isDoseVisible = useRecoilValue(doseVisibilityState);
    return currentDose !== undefined && isDoseVisible;
}
